import type { ListingAuthoringValues } from "./listingAuthoring";
export interface ListingDraftEdits { values: ListingAuthoringValues; details: string; answers: Record<string, string> }
// A per-tab checkpoint covers losing connectivity between typing and server autosave.
// Server versions remain authoritative; recovery is always explicitly reviewed.
export function readListingDraftRecovery(key: string): ListingDraftEdits | undefined {
  try {
    const entry = JSON.parse(sessionStorage.getItem(key) ?? "null");
    if (!entry || typeof entry.at !== "number" || !Number.isFinite(entry.at) || Date.now() - entry.at > 7 * 86400000) return undefined;
    const value = entry.edits as ListingDraftEdits;
    if (typeof value?.values?.title !== "string" || typeof value.values.description !== "string" || !Number.isSafeInteger(value.values.priceMinor) || typeof value.details !== "string" || !value.answers || typeof value.answers !== "object" || Array.isArray(value.answers) || Object.values(value.answers).some((answer) => typeof answer !== "string")) return undefined;
    return value;
  } catch { return undefined; }
}
export function writeListingDraftRecovery(key: string, edits?: ListingDraftEdits) {
  try { if (edits) sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), edits })); else sessionStorage.removeItem(key); } catch { /* Server autosave and unload protection remain available. */ }
}
